import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";

const ForgotPasswordDialog = ({
  open,
  onClose,
  onSendOTP,
  setResetEmail,
  resetEmail,
}) => {
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    const value = event.target.value;
    setResetEmail(value);
    setError(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
  };

  const handleSubmit = () => {
    if (!error && resetEmail) {
      onSendOTP(resetEmail);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setResetEmail("");
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Forgot Password</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Please enter your registered email to receive an OTP for password
          reset.
        </Typography>
        <TextField
          label="Enter your email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={resetEmail}
          onChange={handleChange}
          error={error}
          helperText={error ? "Enter a valid email" : ""}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!resetEmail || error}
          variant="contained"
        >
          Send OTP
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
